import React from 'react';

export const NoHighlightsContainer = ({ children }) => {
  return (
    <div className="md:flex px-6 pb:4 lg:px-16 lg:pb-8 gap-4 md:gap-20 max-w-[1300px] mx-auto">
      {children}
    </div>
  );
};
